<template>
  <!-- 查询条件组件，如果一个元素需要占用两个格式，添加class='double-width',三个格式则添加class='triple-width' -->
  <div ref="condition" class="search-condition" :class="(showBorder? ' border': ' no-border') + (showShadow? ' shadow': ' no-shadow')" >
    <slot />
    <div v-if="enableShowCustomer"  v-for="(item, idx) in customerColumnList" :key="idx"><!-- 不同的类型 -->
      <el-select v-if="item.columnTypeDisplay === 'select' && item.columnSearchType === 1" v-model="customerForm['eq_' + item.columnName]" @change="dateChange" clearable filterable> <!-- select只有相等一种情况 -->
        <template #prefix>{{item.columnLabel}}</template>
        <el-option v-for="option in item.columnSettingOption" :key="option.value" :label="option.value" :value="option.code"/>
      </el-select>
      <el-input v-else-if="item.columnTypeDisplay === 'text'  && item.columnSearchType === 1" v-model="customerForm['eq_' + item.columnName]" placeholder="精确匹配" @change="dateChange"> <!-- text相等 -->
        <template #prefix>{{item.columnLabel}}</template>
      </el-input>
      <el-input v-else-if="item.columnTypeDisplay === 'text'  && item.columnSearchType === 2" v-model="customerForm['like_' + item.columnName]" placeholder="模糊匹配" @change="dateChange"> <!-- text模糊匹配 -->
        <template #prefix>{{item.columnLabel}}</template>
      </el-input>
      <yq-date-picker style="width: 100%" v-else-if="item.columnTypeDisplay === 'date'  && item.columnSearchType === 1" v-model="customerForm['eq_' + item.columnName]" @change="dateChange"> <!-- date相等 -->
        <template #prefix>{{item.columnLabel}}</template>
      </yq-date-picker>
      <yq-date-range v-else-if="item.columnTypeDisplay === 'date'  && item.columnSearchType === 4" v-model:start-time="customerForm['ran1_' + item.columnName]" v-model:end-time="customerForm['ran2_' + item.columnName]" :show-short-cut="false" @change="dateChange"> <!-- date范围 -->
        <template #prefix>{{item.columnLabel}}</template>
      </yq-date-range>
      <yq-date-range v-else-if="item.columnTypeDisplay === 'dateTime'  && item.columnSearchType === 4" v-model:start-time="customerForm['ran1_' + item.columnName]" v-model:end-time="customerForm['ran2_' + item.columnName]" :show-short-cut="false" @change="dateChange"> <!-- dateTime范围 -->
        <template #prefix>{{item.columnLabel}}</template>
      </yq-date-range>
      <el-select v-else-if="item.columnTypeDisplay === 'switch' && item.columnSearchType === 1" v-model="customerForm['eq_' + item.columnName]" @change="dateChange" clearable> <!-- switch只有相等一种情况 -->
        <template #prefix>{{item.columnLabel}}</template>
        <el-option label="是" :value="1"/>
        <el-option label="否" :value="0"/>
      </el-select>
      <el-input v-else-if="item.columnTypeDisplay === 'number'  && item.columnSearchType === 1" v-model="customerForm['eq_' + item.columnName]" type="number" @change="dateChange"> <!-- number相等 -->
        <template #prefix>{{item.columnLabel}}</template>
      </el-input>
      <div class="input-range" v-else-if="item.columnTypeDisplay === 'number'  && item.columnSearchType === 4"><!-- number范围 -->
        <div class="input-range-prefix">{{item.columnLabel}}</div>
        <div class="input-range-value">
          <el-input class="input-range-d" v-model="customerForm['ran1_' + item.columnName]" type="number" placeholder="最小值" @change="dateChange"/>~
          <el-input class="input-range-d" v-model="customerForm['ran2_' + item.columnName]" type="number" placeholder="最大值" @change="dateChange"/>
        </div>
      </div>
      <div class="input-range " v-else-if="item.columnTypeDisplay === 'double'  && item.columnSearchType === 4"><!-- double范围 -->
        <div class="input-range-prefix">{{item.columnLabel}}</div>
        <div class="input-range-value">
          <el-input class="input-range-d" v-model="customerForm['ran1_' + item.columnName]" type="number" placeholder="最小值" @change="dateChange"/>~
          <el-input class="input-range-d" v-model="customerForm['ran2_' + item.columnName]" type="number" placeholder="最大值" @change="dateChange"/>
        </div>
      </div>
      <el-select v-else-if="item.columnTypeDisplay === 'image' && item.columnSearchType === 3" v-model="customerForm['ex_' + item.columnName]" @change="dateChange"> <!-- image是否存在 -->
        <template #prefix>{{item.columnLabel}}</template>
        <el-option label="有照片" :value="1"/>
        <el-option label="无照片" :value="0"/>
      </el-select>
    </div>
    <table-button v-if="hasMoreInfo" class="base text-btn" type="text" @click="showMoreInfoSwitch">
      {{showMoreInfo? $t("message.lessInfo"): $t("message.moreInfo")}}
      <yq-icon name="element-ui_d-arrow-right" :rotate-z="showMoreInfo? '270deg': '90deg'"/>
    </table-button>
    <span class="base float-btn">
      <slot name="option"/>
    </span>
  </div>
</template>

<script>
import TableButton from "@/components/h5/button/TableButton.vue";
import {nextTick, watch} from "vue";
import commonApi from "@/api/commonApi";
import YqDatePicker from "@/components/h5/date/YqDatePicker.vue";
import YqDateRange from "@/components/h5/date/YqDateRange.vue";
// 下级元素使用class=double-width获得双倍宽度
export default {
  props: {
    appName: {default: ""}, // 业务应用
    pageName: {default: ""}, // 页面名称
    modelValue: {type: Object, default: () => {}}, // 查询条件
    miniShowCount: {default: 3},
    showBorder: {default: true},
    // 是否显示阴影
    showShadow: {default: true},
  },
  name: "SC",
  components: {
    TableButton, YqDatePicker, YqDateRange
  },
  data() {
    return {
      showMoreInfo: false, // 是否显示更多信息
      hasMoreInfo: false, // 是否有更多信息，有更多信息时才显示showMoreInfo的按钮
      customerForm: {}, // 自定义字段的值,表单内容
      customerColumnList: [],// 哪些自定义字段可以用于查询条件
      enableShowCustomer: false, // 是否可以显示自定义字段，不显示是因为searchCondition没有收到参数
    };
  },
  created() {
    this.init();
    watch(() => this.modelValue, () => {
      this.init();
    });
    watch(() => this.miniShowCount, () => {
      this.displayShow();
    });
    commonApi.customerTableList(this.pageName).then(list => {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i].columnSearch === 1) {
          if (list[i].columnTypeDisplay === 'select' || list[i].columnTypeDisplay === 'selectMulti') {
            list[i].columnSettingOption = JSON.parse(list[i].columnSetting);
          }
          arr.push(list[i]);
        }
      }
      this.customerColumnList = arr;
      this.$nextTick().then(() => {
        this.displayShow();
      })
    })
  },
  mounted() {

  },
  methods: {
    showMoreInfoSwitch() {
      this.showMoreInfo = !this.showMoreInfo;
      this.displayShow();
    },
    // 显示数据：超过 miniShowCount 的查询条件默认隐藏，通过"更多"按钮控制显示/隐藏。
    // 使用 JS 逐条控制 display，替代 nth-child 选择器，使 miniShowCount 可通过参数动态调整。
    async displayShow() {
      const container = this.$refs.condition;
      if (!container) {
        return;
      }
      await nextTick();
      const children = Array.from(container.children || []);
      // 查询条件之外的固定节点：更多按钮(.text-btn)、操作按钮(.float-btn)
      const normalChildren = children.filter(el => !(el.classList && (el.classList.contains('text-btn') || el.classList.contains('float-btn'))));
      const hiddenCount = Math.max(0, normalChildren.length - this.miniShowCount);
      this.hasMoreInfo = hiddenCount > 0;
      // 在展开状态下只补全，不折叠（避免展开后切换 miniShowCount 导致条件被强制隐藏）
      if (this.showMoreInfo) {
        normalChildren.forEach(el => el.style.display = '');
        return;
      }
      normalChildren.forEach((el, index) => {
        el.style.display = index >= this.miniShowCount ? 'none' : '';
      });
      this.showMoreInfo = false;
    },
    init() {
      if (this.modelValue === null || this.modelValue === undefined) {
        this.enableShowCustomer = false;
        return;
      }
      this.enableShowCustomer = true;
      this.customerForm = this.modelValue.customerForm || {};
    },
    // 数据变更时，同步到父组件
    dateChange() {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        customerForm: this.customerForm
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-condition{
  --single-width: calc(16.667% - 10px); // 单倍宽度
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
  justify-content: flex-start;
  padding: 20px;
  align-items: center;
  :deep(>*){ // 查询条件，统一设置边框，由于el-input,el-select的样式不一样，会导致显示不一致，所以统一设置边框，在内部取消el的边框，为保持样式，使用shadow代替边框，el都是这样设置的
    width: var(--single-width);

    &.float-btn{
      margin-left: auto; // 添加这一行，让 option slot 向右对齐
      white-space: nowrap;
      overflow: hidden;
      text-align: right;
      width: auto;
    }
    &.text-btn{
      margin-right: 0;
      width: auto;
    }
    &.double-width{
      width: calc(33.333% - 8px);
    }
    &.triple-width{
      width: calc(50% - 6px);
    }
  }
}
.no-border.no-shadow{
  padding: 0 !important;
}

.input-range{
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color)) inset;
  border-radius: var(--el-input-border-radius, var(--el-border-radius-base));
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 1px;
  .input-range-prefix{
    white-space: nowrap;
    padding-left: 10px;
    font-size: 14px;
    &:after{
      content: ':';
    }
  }
  .input-range-value{
    flex: 1;
    display: flex;
    align-items: center;
    .input-range-d{
      width: calc(50% - 10px);
    }
    :deep(.el-input){
      .el-input__wrapper{
        box-shadow: none;
        padding-left: 5px;
      }
    }
  }

}
</style>